// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_loaderContainer__IC3lE {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 300px;
}

.loader_loaderBox__s8YBP {
  display: flex;
  align-items: center;
  gap: 6px;
}

.loader_loader__EsrvX {
  width: 45px;
  height: 45px;
  color: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/Components/atoms/Loader/loader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B","sourcesContent":[".loaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-height: 300px;\n}\n\n.loaderBox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.loader {\n  width: 45px;\n  height: 45px;\n  color: var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderContainer": `loader_loaderContainer__IC3lE`,
	"loaderBox": `loader_loaderBox__s8YBP`,
	"loader": `loader_loader__EsrvX`
};
export default ___CSS_LOADER_EXPORT___;
